export default {
  // GET Requests //

  // Gets all content data
  async getContentData(context) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];
    let httpStatus;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/topic/retrieve-all-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      httpStatus = response.status;
      response = await response.json();
    } catch (err) {
      return 500;
    }

    if (httpStatus !== 200) {
      return httpStatus;
    }

    context.commit("topics", response.topics);

    var contentPayload = [];
    response.content.forEach((content) => {
      var topicList = [];
      content.topics.forEach((top) =>
        topicList.push({
          topicId: top.topicId,
          subCategoryId: top.subCategoryId,
        })
      );

      contentPayload.push({
        contentId: content.contentId,
        contentName: content.contentName,
        contentType: content.contentType,
        published: content.published,
        contentFile: content.contentFile || null,
        topics: topicList,
      });
    });
    context.commit("content", contentPayload);

    var categoriesPayload = [];
    response.categories.forEach((category) => {
      categoriesPayload.push({
        value: category.categoryId,
        name: category.categoryName,
      });
    });
    context.commit("categories", categoriesPayload);
    context.commit("topicsTimestamp");

    return 200;
  },
  // Get specific content data
  async getContent(context, payload) {
    const token = context.rootGetters["authData/token"];
    const userId = context.rootGetters["userData/userId"];
    const contentId = payload.contentId;
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/content/retrieve/" +
          userId +
          "/" +
          contentId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var topicList = [];
    response.topics.forEach((top) =>
      topicList.push({ topicId: top.topicId, subCategoryId: top.subCategoryId })
    );

    const contentObj = {
      contentId: response.contentId,
      contentName: response.contentName,
      published: response.published,
      contentType: response.contentType,
      contentHtml: response.contentHtml || null,
      contentVideo: response.contentVideo || null,
      contentFile: response.contentFile || null,
      primaryLanguage: response.primaryLanguage || "en",
      lastModified: response.lastModified,
      topics: topicList,
    };

    var contentPayload = context.state.content;
    var updated = false;
    for (let i = 0; i < contentPayload.length; i++) {
      if (contentPayload[i].contentId == contentId) {
        contentPayload[i] = contentObj;
        updated = true;
      }
    }

    if (!updated) {
      contentPayload.push(contentObj);
    }

    context.commit("content", contentPayload);

    return contentObj;
  },
  // POST Requests //
  async postTopic(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];

    const bodyContent = {
      companyId: companyId,
      topicName: payload.topicName,
      categoryId: payload.categoryId,
      audience: payload.audience,
      departments: payload.departments,
      locations: payload.locations,
    };

    try {
      response = await fetch(process.env.VUE_APP_NODE_SERVER + "/topic/add", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(bodyContent),
      });
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    var topicsPayload = context.state.topics;
    topicsPayload.push({
      topicId: response.topicId,
      topicName: response.topicName,
      categoryId: response.categoryId,
      visits: response.visits,
      audience: response.audience,
      departments: response.departments,
      locations: response.locations,
      contact: response.contact,
    });

    context.commit("topics", topicsPayload);

    return {
      status: 201,
      topicId: response.topicId,
    };
  },
  // Add new content
  async postContent(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];
    let response;

    try {
      response = await fetch(process.env.VUE_APP_NODE_SERVER + "/content/add", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          userId: userId,
          public: false,
          published: payload.published,
          contentName: payload.contentName,
          contentType: payload.contentType,
          subCategoryId: payload.subCategoryId,
          topicId: payload.topicId,
          primaryLanguage:
            payload.primaryLanguage ||
            context.rootGetters["userData/selectedCulture"],
          contentHtml: payload.contentHtml || null,
          contentVideo: payload.contentVideo || null,
          contentFile: payload.contentFile || null,
        }),
      });
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    var contentPayload = context.state.content;
    contentPayload.push({
      contentId: response.contentId,
      contentName: response.contentName,
      published: response.published,
      primaryLanguage: response.primaryLanguage,
      contentType: response.contentType,
      contentHtml: payload.contentHtml || null,
      contentVideo: payload.contentVideo || null,
      contentFile: payload.contentFile || null,
      topics: [
        {
          topicId: payload.topicId,
          subCategoryId: payload.subCategoryId,
        },
      ],
    });

    context.commit("content", contentPayload);

    return {
      status: 201,
      contentId: response.contentId,
      contentName: response.contentName,
    };
  },
  // Uploads video file to serve
  async postUploadContentVideo(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fileName =
      payload.contentId +
      "." +
      payload.file.type.substring(payload.file.type.lastIndexOf("/") + 1);
    const chunkSize = 6000000;
    const totalChunks = Math.ceil(Number(payload.file.size) / chunkSize);

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/content/initiate-video-upload",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            fileName: fileName,
          }),
        }
      );
      session = await session.json();
      const uploadId = session.uploadId;

      let start = 0;
      let end;

      var uploadedPromises = [];
      for (let i = 0; i < totalChunks; i++) {
        end = start + chunkSize;
        var chunk = payload.file.slice(start, end);
        let fd = new FormData();
        fd.append("file", chunk);
        fd.append("fileName", fileName);
        fd.append("index", i);
        fd.append("uploadId", uploadId);

        session = await fetch(
          process.env.VUE_APP_NODE_SERVER + "/content/upload-video-chunk",
          {
            method: "POST",
            mode: "cors",
            headers: {
              Authorization: "Bearer " + token,
            },
            body: fd,
          }
        );
        session = await session.json();
        uploadedPromises.push(session);
        start = end;
      }

      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/content/upload-video-complete",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            fileName: fileName,
            uploadId: uploadId,
          }),
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }
    session.status = 201;
    session.type = payload.file.type;
    session.size = payload.file.size;
    return session;
  },
  // Uploads pdf file to server
  async postUploadContentPDF(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fd = new FormData();
    fd.append(
      "file",
      payload.file,
      payload.topicId + "_file_" + String(new Date().getTime())
    );

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/content/upload-file",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }

    return {
      status: 201,
      source: session.source,
      type: session.type,
      size: session.size,
    };
  },
  // Add a category
  async postAddCategory(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/topic/add-category",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            categoryName: payload.categoryName,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var categoriesPayload = [];
    response.categories.forEach((category) => {
      categoriesPayload.push({
        value: category.categoryId,
        name: category.categoryName,
      });
    });

    context.commit("categories", categoriesPayload);
    return 201;
  },
  // PATCH Requests //

  // Update existing content
  async patchContent(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/content/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: userId,
            public: false,
            contentId: payload.contentId,
            published: payload.published,
            contentName: payload.contentName,
            subCategoryId: payload.subCategoryId || null,
            topicId: payload.topicId || null,
            contentHtml: payload.contentHtml || null,
            contentVideo: payload.contentVideo || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var contentPayload = context.state.content;

    for (let i = 0; i < contentPayload.length; i++) {
      if (contentPayload[i].contentId == response.contentId) {
        var topicList = [];
        response.topics.forEach((top) =>
          topicList.push({
            topicId: top.topicId,
            subCategoryId: top.subCategoryId,
          })
        );

        contentPayload[i] = {
          ...contentPayload[i],
          contentName: response.contentName,
          published: response.published,
          contentType: response.contentType,
          ...(payload.contentHtml ? { contentHtml: payload.contentHtml } : {}),
          ...(payload.contentVideo ? { contentVideo: payload.contentVideo } : {}),
          topics: topicList,
        };
        break;
      }
    }

    context.commit("content", contentPayload);

    return {
      status: 200,
      contentId: response.contentId,
    };
  },
  // Update existing topic
  async patchTopic(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];

    var bodyContent = {
      companyId: companyId,
      public: false,
      topicId: payload.topicId,
      topicName: payload.topicName || null,
      categoryId: payload.categoryId || null,
      audience: payload.audience,
      departments: payload.departments,
      locations: payload.locations,
    };

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/topic/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(bodyContent),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var topicsPayload = context.state.topics;
    for (let i = 0; i < topicsPayload.length; i++) {
      if (topicsPayload[i].topicId == response.topicId) {
        topicsPayload[i] = {
          topicId: response.topicId,
          topicName: response.topicName,
          categoryId: response.categoryId,
          audience: response.audience,
          locations: response.locations,
          departments: response.departments,
          visits: response.visits,
          contact: {
            fullName: response.contact.fullName || null,
            companyRole: response.contact.companyRole || null,
            emailAddress: response.contact.emailAddress || null,
            phoneNumber: response.contact.phoneNumber || null,
          },
        };
        break;
      }
    }

    context.commit("topics", topicsPayload);

    return 200;
  },
  // Add a category
  async patchCategory(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/topic/update-category",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            categoryId: payload.categoryId,
            categoryName: payload.categoryName,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var categoriesPayload = [];
    response.categories.forEach((category) => {
      categoriesPayload.push({
        value: category.categoryId,
        name: category.categoryName,
      });
    });

    context.commit("categories", categoriesPayload);
    return 200;
  },
  // DELETE Requests //

  // Delete a category
  async deleteCategory(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/topic/remove-category",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            categoryId: payload.categoryId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var categoriesPayload = [];
    response.categories.forEach((category) => {
      categoriesPayload.push({
        value: category.categoryId,
        name: category.categoryName,
      });
    });
    context.commit("categories", categoriesPayload);
    return 200;
  },
  // Delete topic
  async deleteTopic(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    try {
      await fetch(process.env.VUE_APP_NODE_SERVER + "/topic/remove", {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          topicId: payload.topicId,
        }),
      });
    } catch (err) {
      console.log(err);
      return 500;
    }

    var topicPayload = context.state.topics.filter((top) => {
      return top.topicId != payload.topicId;
    });
    context.commit("topics", topicPayload);

    return 201;
  },
  // Delete content
  async deleteContent(context, payload) {
    const token = context.rootGetters["authData/token"];
    const contentId = payload.contentId;
    const companyId = context.rootGetters["userData/companyId"];
    try {
      await fetch(process.env.VUE_APP_NODE_SERVER + "/content/remove", {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          contentId: contentId,
        }),
      });
    } catch (err) {
      return 500;
    }

    var contentPayload = context.state.content.filter((con) => {
      return con.contentId != contentId;
    });
    context.commit("content", contentPayload);

    return 200;
  },
  // Reset timestamp
  topicsTimestampReset(context) {
    context.commit("topicsTimestampReset");
  },
};
